
















































import { defineComponent } from '@vue/composition-api';
import NewFeatureBadge from '../new-feature-badge/index.vue';
import TooltipInfo from '../tooltip-info/index.vue';

// import { trackEvent } from '@/track/utils';

const name = 'ttam-switch-container';

export default defineComponent({
  name,
  components: {
    NewFeatureBadge,
    TooltipInfo,
  },
  props: {
    value: {
      type: [Boolean, String, Number, Array],
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    titleHint: {
      type: String,
      default: '',
    },
    // TODO 埋点 待定
    // titleHintHover: {
    //   type: String,
    //   default: '',
    // },
    // titleHintContentShowKey: {
    //   type: String,
    //   default: '',
    // },
    switchHint: {
      type: String,
      default: '',
    },
    switchHintPlacement: {
      type: String,
      default: 'bottom',
    },
    newFeatureHint: {
      type: String,
      default: '',
    },
    tips: {
      type: String,
      default: '',
    },
    linkHref: {
      type: String,
      default: '',
    },
    linkText: {
      type: String,
      default: '',
    },
    tooltipPlacement: {
      type: String,
      default: 'top',
    },
    // TODO 埋点 待定
    // linkClickKey: {
    //   type: String,
    //   default: '',
    // },
    // TODO 埋点 待定
    // trackEventName: {
    //   type: String,
    //   default: '',
    // },
  },
  setup(props, { emit, attrs }) {
    function handleSwitchChange(val) {
      emit('input', val);
      // if (props.trackEventName) {
      //   trackEvent(props.trackEventName as string);
      // }
    }

    return {
      handleSwitchChange,
      name,
    };
  },
});
